export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ShowRoom.754e7416.svg","height":84,"width":104,"blurWidth":0,"blurHeight":0};